import en from './en.json';

export type TKey = keyof typeof en;

export function t(key: TKey | string, vars?: Record<string, string | number>): string {
  let template = (en as Record<string, string>)[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      template = template.replaceAll(`{${k}}`, String(v));
    }
  }
  return template;
}
